import { Tooltip } from "antd";
import { formatTime } from "V2.0/utils";
import BulkCampaignStatus from "../BulkCampaignStatus";
import { MdOutlineAttachEmail } from "react-icons/md";
import BulkCampaignActions from "./Components/BulkCampaignActions";
import BulkChatCampaignStats from "./Components/BulkChatCampaignStats";

export default function BulkEmailCampaign(props) {
  const {
    name,
    assistant,
    totalContacts,
    status,
    createdAt,
    chatCampaignDetails,
    onBulkCampaignClick,
    onBulkCampaignDelete,
    onBulkCampaignDownload,
    onBulkCampaignResume,
    onBulkCampaignPause,
    onBulkCampaignCancel,
    onBulkCampaignReport,
    isViewOnly,
  } = props;

  return (
    <div
      className="grid grid-cols-[auto_1fr_auto] gap-x-8 hover:bg-gray-100 hover:bg-gray-100 hover:cursor-pointer hover:outline-zinc-300 outline-zinc-100 rounded-lg p-4 outline"
      onClick={onBulkCampaignClick}
    >
      <div className="flex gap-x-4">
        <div className="flex">
          <MdOutlineAttachEmail className="size-6" />
        </div>
        <div className="flex flex-col gap-y-2 w-[140px]">
          <Tooltip title={name}>
            <p className="truncate text-sm font-semibold">{name}</p>
          </Tooltip>
          <p className="text-xs">{formatTime(createdAt)}</p>
          <div>
            <BulkCampaignStatus status={status} />
          </div>
        </div>
      </div>
      {/* <div>
            <div className="flex flex-col items-start gap-y-2">
              <p className="text-xs">Status</p>
              <Badge color={CAMPAIGN_STATUS_LABEL_COLORS[status]}>
                {status}
              </Badge>
            </div>
          </div> */}
      {/* <div>{assistant}</div> */}
      <div className="grid grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6">
        <BulkChatCampaignStats
          chatCampaignDetails={chatCampaignDetails}
          totalContacts={totalContacts}
        />
      </div>
      <div className="flex items-center">
        <BulkCampaignActions
          isViewOnly={isViewOnly}
          bulkCampaignStatus={status}
          onBulkCampaignResume={onBulkCampaignResume}
          onBulkCampaignDelete={onBulkCampaignDelete}
          onBulkCampaignDownload={onBulkCampaignDownload}
          onBulkCampaignPause={onBulkCampaignPause}
          onBulkCampaignCancel={onBulkCampaignCancel}
          onBulkCampaignReport={onBulkCampaignReport}
        />
      </div>
    </div>
  );
}
